module.exports = __webpack_public_path__ + "static/media/logogse.680f18c8.png";